import { useSupportTicket } from '@/viewmodel/features/support/hooks/useSupportTicket';
import type { SupportTicketView } from '@/viewmodel/features/support/types';

export function useSupportTicketViewModel(onSuccess: (ticket: SupportTicketView) => void): {
  submit: (formData: Record<string, string>) => Promise<void>;
  isSubmitting: boolean;
} {
  const { createTicket, isLoading } = useSupportTicket(onSuccess);
  return { submit: createTicket, isSubmitting: isLoading };
}
